<template>
  <div>
    <template v-if="isLikewizeScanner">
      <!--        :width="isModal ? 125 : width"-->
      <!--        :height="isModal ? 125 : height"-->
      <!--        :ratio="checkIfMobile ? 1 : isModal ? 2.7 : ratio"-->
    <likewize-scanner
        @barcodeHasBeenScanned="barcodeScanned"
        :sound="sound"
        ref="likewizeScanner"
    ></likewize-scanner>
    <scanner-modal
        :modalMessage="modalMessage"
        @modalConfirmed="onModalConfirmed"
    />
    </template>
    <barcode-picker
        v-else
        @barcodeHasBeenScanned="barcodeScanned"
        ref="barcodeScanner"
    ></barcode-picker>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
  name: 'scanner',
  data() {
    return {
      modalMessage: "",
    };
  },

  props: {
    scanner: {
      type: String,
      default: 'auto'
    },
    isModal: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 200
    },
    height: {
      type: Number,
      default: 200
    },
    ratio: {
      type: Number,
      default: 2.3
    },
    sound: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    ...mapGetters(['appRegion', 'user']),

    isLikewizeScanner() {
        return true;

        // if (this.scanner === 'likewize') {
        //     return true;
        // }
        // if (this.scanner === 'auto') {
        //     if (this.appRegion !== 'UK') {
        //         return true;
        //     }
        //     const validUKUsers = [205, 455, 301, 1116, 1141, 1276, 1769, 1899, 2135, 2178, 2106 ,2143];
        //     if (validUKUsers.includes(this.user.id)) {
        //         return true;
        //     }
        // }
        // return false;
    },

    checkIfMobile() {
      return window.innerWidth <= 576;
    }
  },

  methods: {
    barcodeScanned(data) {
      this.$emit('barcodeHasBeenScanned', data);
    },

    showModal(message = "unexpected error") {
      this.modalMessage = message;
      this.$bvModal.show('scanner-modal-info');
      this.$refs.likewizeScanner.toggleModal(true);
    },
    onModalConfirmed() {
      this.$bvModal.hide('scanner-modal-info');
      this.$refs.likewizeScanner.toggleModal(false);
    },

  }
};
</script>
